
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Tab, Tabs } from 'vant'
import 'vant/lib/index.css'
Vue.use(Tab)
Vue.use(Tabs)

@Component({
  name: 'MobileMenuComp'
})
export default class extends Vue {
  @Prop() private menuId!: string
  @Watch('$route')
  onRouteChanged (val: any) {
    console.log(val)
  }

  private units = ['中国职工发展基金会', '中国职工技术协会', '中国继续教育工程协会', '教育部学校规划建设发展中心']
  private activeIndex = 0
  private menus = [
    { id: '', title: '首页', url: 'index.html', status: false },
    { id: '11', title: '新闻公告', url: 'detailPage.html', status: false },
    { id: '10', title: '关于我们', url: 'detailPage.html', status: false },
    { id: '12', title: '组织机构', url: 'detailPage.html', status: false },
    { id: '13', title: '技能提升', url: 'detailPage.html', status: false },
    { id: '14', title: '技术创新', url: 'detailPage.html', status: false },
    { id: '15', title: '技术服务', url: 'detailPage.html', status: false },
    { id: '16', title: '成果评审', url: 'detailPage.html', status: false },
    { id: '17', title: '会员服务', url: 'detailPage.html', status: false },
    { id: '18', title: '战略伙伴', url: 'detailPage.html', status: false },
    { id: '19', title: '政策法规', url: 'detailPage.html', status: false },
    { id: '20', title: '党建工作', url: 'detailPage.html', status: false }
  ]

  mounted () {
    const href = decodeURIComponent(window.location.href)
    this.activeIndex = 0
    if (this.menuId) {
      this.menus.forEach((item, index) => {
        if (this.menuId.includes(item.id)) {
          this.activeIndex = index
        }
      })
    } else {
      this.menus.forEach((item, index) => {
        const getqyinfo = href.split('?')[1]
        // 将参数放在URLSearchParams函数中
        const getqys = new URLSearchParams('?' + getqyinfo)
        const getqycode = getqys.get('menuId')
        if (getqycode) {
          if (getqycode.includes(item.id)) {
            this.activeIndex = index
          }
        }
      })
    }
  }

  jumpToPage (url: string) {
    console.log(url)
    window.location.href = url
  }

  clicktab (name: string, title: string) {
    console.log(name, title)
    const menuId = (this.menus.find(item => item.title === title) as any).id
    const Url = (this.menus.find(item => item.title === title) as any).url
    window.location.href = (`${Url}?menuId=${menuId}`)
  }
}
